<template>
  <e-modal
    :visible="visible"
    :title="title"
    :width="500"
    :loading="loading"
    @close="onClose"
    @ok="onSubmit((e) => onSubmitFun(e))"
  >
    <a-spin tip="Loading..." :spinning="loading">
      <a-form>
        <e-input
          title="标题"
          :labelCol="6"
          :validate="validateInfos.title"
          v-model:value="modelRef.title"
        />

        <e-cascader :labelCol="6" title="上级分类" :options="categorys" v-model:value="parentIds" />

        <e-input
          title="打印机编号"
          :labelCol="6"
          v-model:value="modelRef.printSN"
        />

        <a-row style="padding-left: 0px">
          <a-col :span="12" :offset="1">
            <e-input-number
              title="打印联数"
              v-model:value="modelRef.printCount"
            />
          </a-col>
          <a-col :span="8">
            <e-input-number
              title="顺序"
              v-model:value="modelRef.sort"
            />
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </e-modal>
</template>

<script>
import { defineComponent, ref, reactive, toRaw } from 'vue'
import { Form } from 'ant-design-vue'
import form from '@/mixins/form'
import { DishTypeClass } from '@/apis/dish'
import { dataToCascader, getParentIdArray } from '@/utils'

const useForm = Form.useForm
const api = new DishTypeClass()
export default defineComponent({
  mixins: [form],
  emits: ['ok'],
  components: {},
  props: {
    storeId: {
      type: String,
      default: ''
    }
  },
  setup (props, { emit }) {
    const loading = ref(false)
    const visible = ref(false)
    const isEdit = ref(false)
    const title = ref('')
    const categorys = ref([])
    const parentIds = ref([])

    const modelRef = reactive(api.modelRef)
    const rulesRef = reactive(api.rulesRef)

    const { resetFields, validate, validateInfos } = useForm(
      modelRef,
      rulesRef
    )

    const onClose = () => {
      resetFields()
      parentIds.value = []
      loading.value = false
      visible.value = false
    }

    const filter = (inputValue, path) => {
      return path.some(
        (option) =>
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      )
    }

    return {
      title,
      visible,
      loading,
      categorys,
      parentIds,
      isEdit,
      modelRef,
      validateInfos,
      resetFields,
      validate,
      onClose,
      filter
    }
  },

  methods: {
    open (formData) {
      if (formData) {
        this.modelRef.title = formData.title
        this.modelRef.parentId = formData.parentId
        this.modelRef.sort = formData.sort
        this.modelRef.printSN = formData.printSN
        this.modelRef.printCount = formData.printCount
        this.modelRef.id = formData.id

        this.title = '编辑：' + formData.title
        this.isEdit = true
      } else {
        this.modelRef = reactive(api.modelRef)
        this.title = '添加分类'
        this.isEdit = false
      }

      this.getCategorys()
      this.visible = true
    },

    onReset () {
      this.modelRef.title = ''
      this.modelRef.icon = ''
      this.modelRef.thumbnail = ''
      this.modelRef.banner = ''
    },

    onSubmitFun (e) {
      const data = toRaw(e)
      const pid = this.parentIds[this.parentIds.length - 1]
      data.parentId = pid || 0
      if (this.isEdit) {
        if (data.parentId === data.id) {
          this.$message.error('分类自身不能作为自己的上级')
          return false
        }
        api.update(data).then(() => {
          this.loading = false
          this.$message.success('编辑成功')
          this.$emit('ok')
          this.onClose()
        })
      } else {
        api
          .create(data)
          .then(() => {
            this.loading = false
            this.$message.success('添加成功')
            this.$emit('ok')
            this.onClose()
          })
          .catch((e) => {
            this.loading = false
          })
      }
    },

    setRemark (value, e) {
      const name = this.roles[e.key].name
      this.modelRef.remark = name
    },

    async getCategorys () {
      const list =
        this.$store.state.data.ALL_DISHTYPES.length > 0
          ? this.$store.state.data.ALL_DISHTYPES
          : await this.$store.dispatch('GetAllDishTypes')

      this.categorys = dataToCascader(list, 0)

      if (this.isEdit) {
        const parentIds = getParentIdArray(toRaw(list), this.modelRef.parentId)
        parentIds.sort((a, b) => a - b)
        this.parentIds = parentIds.filter((x) => x > 0)
        console.log(this.parentIds)
      }
    },

    emitChooseIcon (e) {
      this.modelRef.icon = e
      console.log(this.modelRef)
    },
    emitChooseResource (e) {
      const image = e.images[0]
      const field = e.field
      this.modelRef[field] = image
    }
  }
})
</script>

<style lang="less" scoped>
</style>
